import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import AccordionUsage from './AccordionUsage';
import ClientProvider from './client';
export default createDemo(import.meta.url, AccordionUsage, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/accordion/demos/usage/AccordionUsage.tsx",
    "fileName": "AccordionUsage.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Accordion from '@mui/material/Accordion';\nimport AccordionActions from '@mui/material/AccordionActions';\nimport AccordionSummary from '@mui/material/AccordionSummary';\nimport AccordionDetails from '@mui/material/AccordionDetails';\nimport Typography from '@mui/material/Typography';\nimport ExpandMoreIcon from '@mui/icons-material/ExpandMore';\nimport Button from '@mui/material/Button';\n\nexport default function AccordionUsage() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 1,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const id = React.useId();\n  return (\n    <div>\n      <Accordion>\n        <AccordionSummary\n          expandIcon={<ExpandMoreIcon />}\n          aria-controls={`${id}-panel1-content`}\n          id={`${id}-panel1-header`}\n        >\n          <Typography component=\"span\">Accordion 1</Typography>\n        </AccordionSummary>\n        <AccordionDetails>\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse\n          malesuada lacus ex, sit amet blandit leo lobortis eget.\n        </AccordionDetails>\n      </Accordion>\n      <Accordion>\n        <AccordionSummary\n          expandIcon={<ExpandMoreIcon />}\n          aria-controls={`${id}-panel2-content`}\n          id={`${id}-panel2-header`}\n        >\n          <Typography component=\"span\">Accordion 2</Typography>\n        </AccordionSummary>\n        <AccordionDetails>\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse\n          malesuada lacus ex, sit amet blandit leo lobortis eget.\n        </AccordionDetails>\n      </Accordion>\n      <Accordion defaultExpanded>\n        <AccordionSummary\n          expandIcon={<ExpandMoreIcon />}\n          aria-controls={`${id}-panel3-content`}\n          id={`${id}-panel3-header`}\n        >\n          <Typography component=\"span\">Accordion Actions</Typography>\n        </AccordionSummary>\n        <AccordionDetails>\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse\n          malesuada lacus ex, sit amet blandit leo lobortis eget.\n        </AccordionDetails>\n        <AccordionActions>\n          <Button>Cancel</Button>\n          <Button>Agree</Button>\n        </AccordionActions>\n      </Accordion>\n    </div>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 59,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Accordion from '@mui/material/Accordion';\nimport AccordionActions from '@mui/material/AccordionActions';\nimport AccordionSummary from '@mui/material/AccordionSummary';\nimport AccordionDetails from '@mui/material/AccordionDetails';\nimport Typography from '@mui/material/Typography';\nimport ExpandMoreIcon from '@mui/icons-material/ExpandMore';\nimport Button from '@mui/material/Button';\n\nexport default function AccordionUsage() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 1
        },
        "  const id = React.useId();\n  return (\n    <div>\n      <Accordion>\n        <AccordionSummary\n          expandIcon={<ExpandMoreIcon />}\n          aria-controls={`${id}-panel1-content`}\n          id={`${id}-panel1-header`}\n        >\n          <Typography component=\"span\">Accordion 1</Typography>\n        </AccordionSummary>\n        <AccordionDetails>\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse\n          malesuada lacus ex, sit amet blandit leo lobortis eget.\n        </AccordionDetails>\n      </Accordion>\n      <Accordion>\n        <AccordionSummary\n          expandIcon={<ExpandMoreIcon />}\n          aria-controls={`${id}-panel2-content`}\n          id={`${id}-panel2-header`}\n        >\n          <Typography component=\"span\">Accordion 2</Typography>\n        </AccordionSummary>\n        <AccordionDetails>\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse\n          malesuada lacus ex, sit amet blandit leo lobortis eget.\n        </AccordionDetails>\n      </Accordion>\n      <Accordion defaultExpanded>\n        <AccordionSummary\n          expandIcon={<ExpandMoreIcon />}\n          aria-controls={`${id}-panel3-content`}\n          id={`${id}-panel3-header`}\n        >\n          <Typography component=\"span\">Accordion Actions</Typography>\n        </AccordionSummary>\n        <AccordionDetails>\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse\n          malesuada lacus ex, sit amet blandit leo lobortis eget.\n        </AccordionDetails>\n        <AccordionActions>\n          <Button>Cancel</Button>\n          <Button>Agree</Button>\n        </AccordionActions>\n      </Accordion>\n    </div>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 59,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Accordion",
      "@mui/material/AccordionActions",
      "@mui/material/AccordionSummary",
      "@mui/material/AccordionDetails",
      "@mui/material/Typography",
      "@mui/icons-material/ExpandMore",
      "@mui/material/Button"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
